import { render } from "./InvSubclasificaciones.vue?vue&type=template&id=70ce576c&scoped=true"
import script from "./InvSubclasificaciones.vue?vue&type=script&lang=js"
export * from "./InvSubclasificaciones.vue?vue&type=script&lang=js"

import "./InvSubclasificaciones.vue?vue&type=style&index=0&id=70ce576c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ce576c"]])

export default __exports__